import { render } from "./NuevaCotizacion.vue?vue&type=template&id=01745b99"
import script from "./NuevaCotizacion.vue?vue&type=script&lang=js"
export * from "./NuevaCotizacion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__